import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchFollowersApi } from "../../API/API";

function* fetchFollowersSaga(action) {
  try {
    const response = yield call(() => fetchFollowersApi());
    yield put({ type: types.GET_FOLLOWERS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_FOLLOWERS_FAILURE, error });
  }
}

export function* watchFetchFollowersSaga() {
  yield takeEvery(types.GET_FOLLOWERS_REQUESTED, fetchFollowersSaga);
}
